<template lang="pug">
.v-catalog.catalog
	v-loader(:loading="loading")
	.container
		template(v-if="!catalog")
			.catalog__placeholder
		template(v-if="catalog")
			.catalog__layout
				.catalog__layout-aside
					button.catalog__aside-close(type="button" @click="closeAside")
						v-svg-icon.catalog__aside-close-icon(icon="close")
					.catalog__layout-aside-container
						.catalog__layout-aside-container-inner
							.catalog__filter.flc(v-if="catalog.links || catalog.filters")
								v-filter(ref="filter"
										:filters="catalog.filters"
										:links="catalog.links"
										@filter-changed="filterChanged"
										@filter-updated="filterUpdated" 
										@request-reset="resetFilter" 
										@request-reset-all="resetAllFilters")
									template(#sort="" v-if="catalog.sort")
										v-field(:field="{type: 'select', options: catalog.sort.options}"
												v-model="state.sort"
												@update:model-value="sortChanged")
									template(#view="" v-if="catalog.view")
										v-field(:field="{type: 'view-picker', options: catalog.view.options}"
												v-model="state.view")
				.catalog__layout-main
					.catalog__top-nav.flc(v-if="catalog.sort || catalog.view && catalog.view.options && catalog.view.options.length")
						.catalog__top-nav-grid
							.catalog__top-nav-cell.catalog__top-nav-cell--active-filters(v-if="changedFilters && changedFilters.length")
								v-filter-active-items(:filters="changedFilters" @reset-filter="resetFilter")
							.catalog__top-nav-cell.catalog__top-nav-cell--aside-toggle(v-if="catalog.filters || catalog.links")
								button.catalog__aside-toggle(type="button" @click="openAside")
									v-svg-icon.catalog__aside-toggle-icon(icon="placeholder")
							.catalog__top-nav-cell.catalog__top-nav-cell--select(v-if="catalog.sort")
								v-field(:field="{type: 'select', options: catalog.sort.options}"
										v-model="state.sort"
										@update:model-value="requestDataLoad")
							.catalog__top-nav-cell.catalog__top-nav-cell--view(v-if="catalog.view")
								v-field(:field="{type: 'view-picker', options: catalog.view.options}"
										v-model="state.view")
					.catalog__list.flc
						transition(name="fade" mode="out-in")
							.catalog__list-message.flc(v-if="!catalog.items || !catalog.items.length")
								.catalog__list-message-title.h3.flc Ничего не найдено
								.catalog__list-message-body.flc Попробуйте изменить параметры поиска или перейдите на главную страницу.
								.catalog__list-message-actions.flc
									.catalog__list-message-actions-grid
										.catalog__list-message-action(v-if="changedFilters && changedFilters.length")
											button.btn(type="button" @click="resetAllFilters") Очистить фильтр
										.catalog__list-message-action
											a.btn(href="/") На главную страницу
							v-product-grid(v-else-if="state.view === 'grid' && catalog.type === 'products'"
									:items="catalog.items"
									quick-view)
							v-product-list(v-else-if="state.view === 'list' && catalog.type === 'products'"
									:items="catalog.items"
									quick-view)
							v-article-grid(v-else-if="catalog.type === 'articles'"
									:items="catalog.items")
					.catalog__nav.flc
						v-page-nav(:page="catalog.page" @navigate="navigate")
</template>

<script>
import controller from '../scripts/controller/controller.js';
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			catalog: null,
			state: {
				page: null,
				sort: null,
				view: null,
				filter: null
			},
			changedFilters: null,
			asideOpen: false
		};
	},

	mounted() {
		// Штампуем текущую страницу (offset) в URL прямо перед уходом со страницы
		// (клик по объявлению и т.п.) — гарантированно последним действием, чтобы
		// браузерный «Назад» вернул на ту же страницу списка (сервер отрендерит её
		// по offset из URL). Надёжнее правки URL во время пагинации (не перезатрётся).
		window.addEventListener('pagehide', this.syncPageUrl);
	},

	unmounted() {
		window.removeEventListener('pagehide', this.syncPageUrl);
	},

	methods: {
		dataSet(data, options = {}) {
			if (options.append && this.catalog && this.catalog.items) {
				let oldItems = this.catalog.items;
				this.catalog = data;
				this.catalog.items = oldItems.concat(this.catalog.items);
			} else {
				if (!this.remoteSet && !this.catalog && data.remoteSet) {
					this.remoteSet  = data.remoteSet;
				}
				this.catalog = data;
			}
			if (this.remoteSet && this.catalog.remoteSet && this.remoteSet !== this.catalog.remoteSet) {
				history.pushState(this.catalog.remoteSet, this.catalog.seo.title, this.catalog.remoteSet);
				this.remoteSet = this.catalog.remoteSet;
				if (this.catalog.seo) {
					if (document.title !== this.catalog.seo.title) {
						document.title = this.catalog.seo.title;
					}
					if (!document.querySelector('meta[name="description"]')) {
						let meta = document.createElement('meta');
						meta.name = 'description';
						document.getElementsByTagName('head')[0].appendChild(meta);
					}
					if (!document.querySelector('meta[name="keywords"]')) {
						let meta = document.createElement('meta');
						meta.name = 'keywords';
						document.getElementsByTagName('head')[0].appendChild(meta);
					}
					if (this.catalog.seo.robots && document.querySelector('meta[name="robots"]')) {
						document.querySelector('meta[name="robots"]').setAttribute('content', this.catalog.seo.robots);
					} else if (this.catalog.seo.robots && !document.querySelector('meta[name="robots"]')) {
						let meta = document.createElement('meta');
						meta.name = 'robots';
						document.getElementsByTagName('head')[0].appendChild(meta);
						document.querySelector('meta[name="robots"]').setAttribute('content', this.catalog.seo.robots);
					} else if (!this.catalog.seo.robots && document.querySelector('meta[name="robots"]')) {
						document.querySelector('meta[name="robots"]').remove();
					}
					if (this.catalog.seo.canonical && document.querySelector('link[rel="canonical"]')) {
						document.querySelector('link[rel="canonical"]').setAttribute('href', this.catalog.seo.canonical);
					} else if (this.catalog.seo.canonical && !document.querySelector('link[rel="canonical"]')) {
						let meta = document.createElement('link');
						meta.rel = 'canonical';
						meta.href = this.catalog.seo.canonical;
						document.getElementsByTagName('head')[0].appendChild(meta);
					} else if (!this.catalog.seo.canonical && document.querySelector('link[rel="canonical"]')) {
						document.querySelector('link[rel="canonical"]').remove();
					}
					document.querySelector('meta[name="description"]').setAttribute('content', this.catalog.seo.description);
					document.querySelector('meta[name="keywords"]').setAttribute('content', this.catalog.seo.keywords);
					if (document.querySelector('#bx-panel')) {
						document.querySelector('#bx-panel').remove();
					}
					this.$store.commit('breadcrumbs/set', this.catalog.seo.chain);
				}
			}
			this.state.sort = this.catalog.sort ? this.catalog.sort.value : null;
			this.state.page = this.catalog.page;
			this.state.view = this.state.view || this.catalog.view && this.catalog.view.value || 'grid';
		},

		navigate(page) {
			this.state.page.offset = page.offset;
			this.state.page.limit = page.limit;
			this.requestDataLoad({append: page.append});
			if (!page.append) this.syncPageUrl();
		},

		// Синхронизируем номер страницы (offset) в URL, чтобы при возврате из карточки
		// объявления (браузерный «Назад») сервер отрендерил ту же страницу списка, а не
		// первую. Бэкенд читает page[offset]/page[limit] из запроса и рендерит нужную
		// страницу (SSR), нативное восстановление скролла подводит к тому же объявлению.
		syncPageUrl() {
			try {
				if (window.location.pathname.indexOf('/local/') > -1) return;
				const offset = parseInt(this.state.page && this.state.page.offset) || 0;
				const limit = parseInt(this.state.page && this.state.page.limit) || 0;
				const params = (window.location.search || '').replace(/^\?/, '')
					.split('&').filter(p => p && !/^page(\[|%5B)/i.test(p));
				if (offset > 0) {
					params.push('page[offset]=' + offset);
					params.push('page[limit]=' + limit);
				}
				const search = params.length ? '?' + params.join('&') : '';
				window.history.replaceState(window.history.state, document.title,
					window.location.pathname + search + window.location.hash);
			} catch (e) {}
		},

		sortChanged() {
			this.state.pages.offset = 0;
			this.requestDataLoad();
		},

		filterUpdated(filterValue, changedFilters) {
			this.state.filter = filterValue;
			this.changedFilters = changedFilters;
			// update url except markup pages
			if (window.location.pathname.indexOf('/local/') < 0) {
				window.history.replaceState(null, null, this.catalog.remote);
			}
		},

		filterChanged(filterValue) {
			this.state.filter = filterValue;
			this.requestDataLoad();
		},

		requestDataLoad(dataSetOptions) {
			this.dataLoad({
				url: this.catalog.remote,
				delay: true,
				data: {
					page: this.state.page,
					sort: this.state.sort,
					filter: this.state.filter
				}
			}, dataSetOptions);
		},

		openAside() {
			controller.openCatalogAside();
		},

		closeAside() {
			controller.closeCatalogAside();
		},
		
		resetFilter(e) {
			this.$refs.filter.resetFilter(e);
		},
		
		resetAllFilters(e) {
			this.$refs.filter.resetAll(e);
		}
	}
};
</script>